import * as actions from "./actions";
import { Map } from "immutable";
import { Record } from "../transit";
import { ValidationError } from "../lib/validation";

import { hashFromObj } from "../lib/utils/hash";

import { normalize, Schema, arrayOf } from "normalizr";

const article = new Schema("articles", { idAttribute: "slug" });

const State = Record(
  {
    map: Map(),
    results: Map(),
    meta: new (Record(
      {
        currentPage: 1,
        limit: 9,
        offset: 0,
        sortDir: "desc",
        sortField: "created_at",
      },
      "meta"
    ))(),
  },
  "article"
);

const articlesReducer = (state = new State(), action) => {
  switch (action.type) {
    case actions.GET_ARTICLES_SUCCESS: {
      const { body, data } = action.payload;
      const nrs = normalize(body, { articles: arrayOf(article) });

      delete data.search;

      return state
        .update("map", (map) => map.merge(nrs.entities.articles))
        .update("results", (rs) => rs.set(hashFromObj(data), nrs.result));
    }

    case actions.GET_ARTICLE_SUCCESS: {
      const { body, data } = action.payload;
      const nrs = normalize(body, article);
      return state.update("map", (map) => map.merge(nrs.entities.articles));
    }

    case actions.SET_ARTICLE_PAGE: {
      const { page } = action.payload;
      const limit = state.getIn(["meta", "limit"]);
      return state
        .setIn(["meta", "currentPage"], page)
        .setIn(["meta", "offset"], (page - 1) * limit);
    }

    case actions.SET_ARTICLE_SORT: {
      const { field, dir } = action.payload;
      return state
        .setIn(["meta", "sortDir"], dir)
        .setIn(["meta", "sortField"], field);
    }

    default:
      return state;
  }
};

export default articlesReducer;



/** WEBPACK FOOTER **
 ** ./src/common/article/reducer.js
 **/